var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExport = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 15.412a.83.83 0 0 1-.633-.256l-3.11-3.11a.7.7 0 0 1-.22-.522.77.77 0 0 1 .22-.532.77.77 0 0 1 .535-.24q.303-.008.535.225L11.25 12.9V5.25q0-.32.216-.535A.73.73 0 0 1 12 4.5q.32 0 .534.215a.73.73 0 0 1 .216.535v7.65l1.923-1.923a.71.71 0 0 1 .53-.22q.306.003.54.235.217.233.224.527a.7.7 0 0 1-.225.527l-3.11 3.11a.83.83 0 0 1-.632.255ZM6.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283v-1.961a.73.73 0 0 1 .215-.535.73.73 0 0 1 .535-.215.73.73 0 0 1 .535.215.73.73 0 0 1 .215.535v1.961q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-1.961a.73.73 0 0 1 .215-.535.73.73 0 0 1 .535-.215.73.73 0 0 1 .535.215.73.73 0 0 1 .215.535v1.961q0 .758-.525 1.283t-1.283.525z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/export.8f74615f.svg";